import { useAuth, db } from '@/lib/db'
import type { Profile, Organization } from '@/types'

/**
 * 用户档案 Hook
 * 获取当前登录用户的档案信息
 */
export function useProfile() {
  const auth = useAuth()

  // 查询当前用户档案及所属企业
  const { data, isLoading, error } = db.useQuery({
    profiles: {
      $: {
        where: { id: auth.user?.id },
      },
    },
    organizations: {},
  })

  const profile = data?.profiles?.[0] as Profile | undefined
  const organization = data?.organizations?.find(org => org.id === profile?.org_id) as Organization | undefined

  return {
    profile,
    organization,
    isLoading,
    error,
    user: auth.user,
  }
}




